import { isString } from '@/modules/validate';
import { JsBridge } from '@/interface';

const isRealizeObject = (data: string): boolean => /{.+}/.test(data);

export function formatData(
  data: Record<string, unknown> | string,
  options?: { isDeep?: boolean }
): string | any {
  try {
    // 字符串并且需要序列化
    if (isString(data) && isRealizeObject(data)) {
      const result = JSON.parse(data);

      if (options?.isDeep) {
        for (const key in result) {
          result[key] = formatData(result[key], { isDeep: options.isDeep });
        }
      }

      return result;
    }

    // 对象情况
    if (!isString(data) && options?.isDeep) {
      for (const key in data) {
        data[key] = formatData(data[key] as any, { isDeep: options.isDeep });
      }
    }

    return data;
  } catch {
    return data;
  }
}

/**
 * jsbridge专属方法，请不要暴露出去
 */
// eslint-disable-next-line
export const tryCatch = (
  cb: (
    resolve: (value?: unknown | JsBridge.IConfigData) => unknown,
    reject: (error?: unknown) => void
  ) => unknown
): Promise<any> => {
  // eslint-disable-next-line
  return new Promise(
    (resolve: (value?: unknown) => void, reject: (error?: unknown) => void): any => {
      try {
        cb(resolve, reject);
      } catch (e) {
        console.error(e);
        reject(e);
      }
    }
  );
};
